function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseTemplate from "components/templates/base-template";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import { StyledErrorCareersComponent } from "./error-careers-common-styls.scss";
class ErrorCareersComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread({}, this.props), {
            children: [
                /*#__PURE__*/ _jsx(BaseHeaderComponent, {}),
                /*#__PURE__*/ _jsx(StyledErrorCareersComponent, {
                    className: "error-careers-component",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "error-message",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                className: "cactus",
                                src: "/static/img/careers/cactus.png"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "title",
                                children: this.getMessage()
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "content",
                                children: [
                                    "Check out all of ",
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "/careers/",
                                        children: "our open positions"
                                    }),
                                    "!"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(LongFooterComponent, {})
            ]
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getMessage", ()=>{
            const { statusCode } = this.props;
            if (statusCode === 404 || statusCode === 410) return "Position not found";
            return "Sorry, something went wrong";
        });
    }
}
export { ErrorCareersComponent as default };
